import { ChakraProvider, ColorModeScript } from "@chakra-ui/react"
import * as Sentry from "@sentry/react"
import * as React from "react"
import * as ReactDOM from "react-dom/client"
import { App } from "./App"
import theme from "./theme"
import reportWebVitals from "./reportWebVitals"
import * as serviceWorker from "./serviceWorker"

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_CURRENT_ENV || 'development',
  integrations: [Sentry.browserTracingIntegration()],

  // Capture 20% of transactions for performance monitoring in production
  tracesSampleRate: process.env.REACT_APP_CURRENT_ENV === 'production' ? 0.2 : 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "https://chatsocapi.sullivanoncomp.com", "https://staging-chatsocapi.sullivanoncomp.com"],
  // Off: sendDefaultPii would send IP addresses, cookies, and user details to Sentry, which is not covered by
  // a BAA. Errors still report; they just carry no personal data.
  sendDefaultPii: false
});


const container = document.getElementById("root")
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container)

root.render(
  <>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

